<template>
  <v-flex xs12>
    <section class="appointment-panel" :class="{ dark: isDark }" @click="openEvent">
      <div class="appointment-header">
        <v-avatar class="appointment-icon" size="38">
          <v-icon>{{ iconStatus(external_movimentation.status) }}</v-icon>
        </v-avatar>
        <div>
          <strong>Agendamento</strong>
          <small>{{ external_movimentation.visit_date }} {{ external_movimentation.visit_hour }}</small>
        </div>
        <v-spacer />
        <v-chip small :color="iconStatusColor(external_movimentation.status)" dark>
          {{ statusLabel(external_movimentation.status) }}
        </v-chip>
      </div>

      <div class="appointment-grid">
        <div v-if="external_movimentation.address_destiny" class="appointment-card">
          <v-icon color="#1f8f55">mdi-map-marker-path</v-icon>
          <span>
            <strong>Destino</strong>
            <small>{{ addressLabel }}</small>
          </span>
        </div>
        <div class="appointment-card">
          <v-icon color="#1f8f55">mdi-truck-delivery-outline</v-icon>
          <span>
            <strong>{{ responsiblesLabel }}</strong>
            <small>Responsáveis pelo agendamento</small>
          </span>
        </div>
        <div class="appointment-card">
          <v-icon color="#1f8f55">mdi-calendar-check-outline</v-icon>
          <span>
            <strong>{{ typeLabel(external_movimentation.type) }}</strong>
            <small>Tipo do agendamento</small>
          </span>
        </div>
      </div>
    </section>
  </v-flex>
</template>

<script>
export default {
  props: {
    external_movimentation: {
      type: Object,
      default: () => ({})
    },
    openEvent: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    isDark() {
      return localStorage.dark === "true";
    },
    executor() {
      if (this.external_movimentation.executor && this.external_movimentation.executor.nome) {
        return this.external_movimentation.executor;
      }
      const docs = this.$store.getters["get_funcionarios"].docs || [];
      return docs.find(u => this.external_movimentation.executor == `${u._id}`) || {};
    },
    responsiblesLabel() {
      const names = [
        this.executor && this.executor.nome,
        ...(this.external_movimentation.followers || []).map(follower => follower && follower.nome),
      ].filter(Boolean);
      return names.length ? names.join(", ") : "Responsável não definido";
    },
    addressLabel() {
      const address = this.external_movimentation.address_destiny || {};
      return [address.street, address.bairro, address.number, address.city, address.state].filter(Boolean).join(", ");
    }
  },
  methods: {
    statusLabel(status) {
      return {
        waiting: "Agendado",
        on_the_way: "Saiu para entrega",
        done: "Entregue",
        canceled: "Cancelado"
      }[status] || "Pendente";
    },
    typeLabel(type) {
      return {
        visit: "Visita",
        limit_date: "Data limite de entrega",
        delivery: "Entrega",
        ligacao: "Ligacao",
        email: "E-mail",
        whatsapp: "Whatsapp",
        other: "Outros"
      }[type] || type || "Agendamento";
    },
    iconStatus(status) {
      return {
        waiting: "mdi-clock-outline",
        on_the_way: "mdi-truck-delivery-outline",
        done: "mdi-check-circle-outline",
        canceled: "mdi-close-circle-outline"
      }[status] || "mdi-clock-outline";
    },
    iconStatusColor(status) {
      return {
        waiting: "#2563eb",
        on_the_way: "#c26a13",
        done: "#1f8f55",
        canceled: "#dc2626"
      }[status] || "#64748b";
    }
  }
};
</script>

<style scoped>
.appointment-panel { margin: 10px 8px 14px; padding: 16px; border-radius: 20px; background: #f8fbf9; border: 1px solid #dfe9e4; box-shadow: 0 14px 34px rgba(15, 35, 28, .08); cursor: pointer; }
.appointment-header { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; }
.appointment-header strong,.appointment-header small,.appointment-card strong,.appointment-card small { display: block; }
.appointment-header strong { color: #14251d; font-size: 16px; }
.appointment-header small,.appointment-card small { color: #6f8178; }
.appointment-icon { background: #e8f7ef !important; color: #1f8f55 !important; }
.appointment-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px; }
.appointment-card { display: flex; align-items: flex-start; gap: 10px; padding: 12px; border-radius: 16px; background: #fff; border: 1px solid #e4ece8; min-width: 0; }
.appointment-card span { min-width: 0; }
.appointment-card small { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.appointment-panel.dark { background: #111b21; border-color: #26343c; box-shadow: none; }
.appointment-panel.dark .appointment-header strong,.appointment-panel.dark .appointment-card strong { color: #eef4f1; }
.appointment-panel.dark .appointment-header small,.appointment-panel.dark .appointment-card small { color: #8ea39a; }
.appointment-panel.dark .appointment-card { background: #182229; border-color: #26343c; }
.appointment-panel.dark .appointment-icon { background: #0b3b2a !important; color: #9be7bd !important; }
@media(max-width: 900px) { .appointment-grid { grid-template-columns: 1fr; } }
</style>
